import { AcAppHeader, AcTabs, AcTab } from '@components'
import { LABELS, SYSTEM_TABS } from '@constants'
import { observer } from 'mobx-react-lite'

export const AcSystem = observer(() => {
  return (
    <>
      <AcAppHeader title={LABELS.SYSTEM} />
      <AcTabs tabs={SYSTEM_TABS}>
        <AcTab name={'Job Batches'} />
        <AcTab name={'Jobs'} />
        <AcTab name={'Failed Jobs'} />
      </AcTabs>
    </>
  )
})
